// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { relatedProductCartStyles } from "@plumberssupply/App/Components/SystemBuilder/RelatedProductCart";
import { ellipsis, xScreen } from "@plumberssupply/XDL/Utilities";
import { css } from "styled-components";

relatedProductCartStyles.productGridLayoutStyle = {
    image: {
        css: css`
            margin-right: 12px;
            img {
                margin-bottom: 4px;
            }
        `,
    },
    info: {
        css: css`
            margin-bottom: 8px;
            ${xScreen("lte", "lg")} {
                margin-bottom: 0;
            }
        `,
    },
    addToCartSection: {
        css: css`
            justify-content: flex-start;
            flex: 1;
        `,
    },
    priceSection: {
        css: css`
            min-height: 50px;
        `,
    },
};

relatedProductCartStyles.productDescriptionStyles = {
    productDetailLink: {
        typographyProps: {
            css: css`
                ${ellipsis(2)}
            `,
        },
    },
};

relatedProductCartStyles.productPriceWrapper = {
    css: css`
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        row-gap: 5px;
    `,
};
relatedProductCartStyles.productAddToCartButtonStyles = {
    css: css`
        flex: 1;
        width: auto;
        min-width: unset;
        max-width: 130px;

        ${xScreen("lte", "md")} {
            max-width: unset;
        }
    `,
};
relatedProductCartStyles.roundToBox = {
    wrapper: {
        css: css`
            margin-left: 8px;
        `,
    },
};
relatedProductCartStyles.topSection = {
    css: css`
        display: flex;
        flex-direction: column;
        flex: 0 0 calc(100% - 92px);

        ${xScreen("lte", "md")} {
            flex: 1;
            width: 100%;
        }
    `,
};
relatedProductCartStyles.actionsSection = {
    css: css`
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-top: auto;
        gap: 5px 16px;
        width: 100%;
        ${xScreen("lte", "md")} {
            row-gap: 12px;
            & > div {
                width: 100%;
            }
        }
    `,
};
relatedProductCartStyles.productImageStyles = {
    linkWrappingImage: {
        css: css`
            width: 80px;
            height: 80px;
            margin-right: 12px;
            margin-bottom: 4px;
        `,
    },
};
relatedProductCartStyles.badgeAreaWrapper = {
    css: css`
        position: relative;
    `,
};
relatedProductCartStyles.badgeTextWrapper = {
    css: css`
        position: absolute;
        width: 50%;
        white-space: nowrap;
        overflow: hidden;
    `,
};
relatedProductCartStyles.badgeImageWrapper = {
    css: css`
        position: absolute;
        width: 25%;
        height: 25%;
    `,
};
relatedProductCartStyles.badgeText = {
    weight: "bold",
    css: css`
        width: 100%;
        margin: auto;
        ${wrapInContainerStyles}
    `,
};
